import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsArrowDropUp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="m7 14 5-5 5 5z" />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsArrowDropUp);
const Memo = memo(ForwardRef);
export default Memo;
